import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/FinancialDetails.scss";
import Loader from "../NewComponents/Loader";
import { getBankStatus, setupBank } from "../common/request";

const FinancialDetails = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [bankStatus, setBankStatus] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchBankStatus();
  }, []);

  const fetchBankStatus = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getBankStatus();
      if (data?.success) {
        setBankStatus(data.data);
      }
    } catch (error) {
      console.error("Error fetching bank status:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSetupBank = async () => {
    try {
      setLoading(true);
      const data = await setupBank();
      const link = data?.data?.link;

      if (link) {
        window.open(link, "_blank");
        // Refresh status after a delay
        setTimeout(() => {
          fetchBankStatus();
        }, 2000);
      } else {
        alert("Error: Failed to get onboarding URL.");
      }
    } catch (error) {
      alert(`Error: ${error.message || "Failed to start bank setup."}`);
    } finally {
      setLoading(false);
    }
  };

  if (loading && !bankStatus) {
    return (
      <div className="financial-details-container loading-container">
        <Loader />
      </div>
    );
  }

  const isOnboarded = bankStatus?.onboard_state === "SETUP";
  const isPending = bankStatus?.onboard_state === "PENDING";

  return (
    <div className="financial-details-container headerMargin">
      <div className="financial-content">
        <h1 className="heading">Financial Details</h1>

        {isOnboarded ? (
          <div className="card">
            <div className="status-badge onboarded">
              <span className="status-text">Onboarded & Active</span>
            </div>

            <div className="info-block">
              <label className="info-label">Bank Name</label>
              <p className="info-value">
                {bankStatus?.bank?.bank_name || "Stripe Connect Account"}
              </p>
            </div>

            <div className="info-block">
              <label className="info-label">Account Number</label>
              <p className="info-value">
                **** **** **** {bankStatus?.bank?.last4 || "0000"}
              </p>
            </div>

            <button
              onClick={handleSetupBank}
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? "Loading..." : "Go to Stripe Dashboard"}
            </button>
          </div>
        ) : (
          <div className="card">
            <div className={`status-badge ${isPending ? "pending" : "required"}`}>
              <span className="status-text">
                {isPending ? "Verification Pending" : "Actions Required"}
              </span>
            </div>

            <p className="empty-text">
              {isPending
                ? "Your bank setup is being verified by Stripe. You can click below to check if more information is needed."
                : "You haven't set up your bank details yet. To receive payments from students, you need to complete the Stripe onboarding."}
            </p>

            <button
              onClick={handleSetupBank}
              className="btn btn-add"
              disabled={loading}
            >
              {loading
                ? "Loading..."
                : isPending
                ? "Check Progress"
                : "Start Onboarding"}
            </button>
          </div>
        )}

        {error && (
          <div className="error-message">
            <p>{error}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FinancialDetails;
